<script lang="ts">
    /**
     * @typedef {Object} Props
     * @property {number} [width]
     * @property {number} [height]
     */

    /** @type {Props} */
    let { width = 24, height = 24 } = $props();
</script>
<svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24"><path fill="currentColor" d="M7 19h10c.55 0 1 .45 1 1s-.45 1-1 1H7c-.55 0-1-.45-1-1s.45-1 1-1z"/></svg>
